import {Injectable} from '@angular/core';
import {Book, BookInfo} from "./book.model";
import {HttpClient} from "@angular/common/http";
import {map, Observable, of} from "rxjs";
import {PlatformService} from "../platform/plaform.service";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BookService {

  private books:  { [webId:string]: Book } = {};
  private infos:  { [webId:string]: BookInfo } = {};
  private apiBase: string = '/api/v1';
  constructor(private httpClient: HttpClient,private platform: PlatformService) {

   if(this.platform.isServer){
     this.apiBase = `${environment.apiUrl}/api/v1`;
   }
  }


  save(book: any): Observable<any>{
    console.log(JSON.stringify(book));

    return this.httpClient.post(`${this.apiBase}/book/`, book);
 //   return this.httpClient.post('/api/v1/book', book);
  }
  private getApiBase() {
   let base = '/api/v1';
    if (this.platform.isServer) {
      base = `${environment.apiUrl}/api/v1`;
    }
    console.log('base is: ' + base);
    return base;
  }
  update(id: string, book: any): Observable<any>{
    console.log(JSON.stringify(book));
    return this.httpClient.put(`${this.apiBase}/book/`  + id, book);
  //  return this.httpClient.put('/api/v1/book/' + id, book);
  }

  validate(book: any){

  }

  uploadCoverImage(id: string, file: File): Observable<any>{
    const data: FormData = new FormData();
    data.append('file', file);

    return this.httpClient.put(`${this.apiBase}/book/cover/`  + id, data);
  // return this.httpClient.put('/api/v1/book/cover/' + id, data);
  }

  get(bookId: string): Observable<any>{
    if(this.books[bookId]){
      return of(this.books[bookId]);
    }


    return this.httpClient.get<Book>(`${this.getApiBase()}/book/` + bookId).pipe(
      map((book: Book) => {
        this.books[bookId] = book;
        return book;
      })
    );
    // return this.httpClient.get<Book>('/api/v1/book/' + bookId).pipe(
    //   map((book: Book) => {
    //     this.books[bookId] = book;
    //     return book;
    //   })
    // );
  }

  getInfo(bookId: string): Observable<any>{
    if(this.infos[bookId]){
      return of(this.infos[bookId]);
    }
    return this.httpClient.get<BookInfo>(`${this.apiBase}/book/` + bookId + '/info').pipe(
      map((book: BookInfo) => {
        this.infos[bookId] = book;
        return book;
      })
    );
  }


}
